import { FamilyDetail } from "creso-core/types";
import { EllipsisVerticalIcon, PencilIcon } from "lucide-react";
import { useNavigate } from "@tanstack/react-router";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "web-design-system";
import { DeleteFamily } from "./delete-family";

export function FamilyContextMenu({
  family,
  className,
}: {
  family?: FamilyDetail;
  className?: string;
}) {
  const navigate = useNavigate();

  if (!family) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button className={className} variant="ghost" size="icon">
          <EllipsisVerticalIcon />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem
          onSelect={() =>
            navigate({
              to: ".",
              search: (prev) => ({
                ...prev,
                modal: "modify-family",
                family_id: family.id,
              }),
            })
          }
        >
          <PencilIcon />
          Modify
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <DeleteFamily family={family} />
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
